var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 839.39,
    height: 666.333,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 78",
    cx: 55.1,
    cy: 55.1,
    r: 55.1,
    transform: "translate(393.422 30.958)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 474",
    d: "M282.615 351.24c0 106.421-63.266 143.579-141.308 143.579S0 457.661 0 351.24s141.307-241.806 141.307-241.806S282.615 244.819 282.615 351.24z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 475",
    d: "M136.161 478.54l1.446-89.064 60.229-110.186-60 96.214.65-40.047 41.51-79.719-41.338 69.121 1.171-72.026 44.452-63.467-44.265 52.14.731-132.072-4.594 174.838.377-7.212-45.192-69.174 44.468 83.02-4.211 80.441-.126-2.135-52.1-72.8 51.941 80.338-.527 10.06-.094.152.043.826-10.686 204.09h14.274l1.711-105.414 51.814-80.14z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 476",
    d: "M701.367 295.408c0 130.012-77.29 175.408-172.632 175.408s-172.632-45.4-172.632-175.408S528.732 0 528.732 0s172.635 165.396 172.635 295.408z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 477",
    d: "M522.443 450.928l1.768-108.808 73.58-134.612-73.3 117.543.8-48.925 50.711-97.39-50.5 84.443 1.429-87.993 54.3-77.535-54.078 63.7L528.041 0l-5.618 213.6.461-8.812-55.21-84.507 54.33 101.419-5.145 98.273-.152-2.608-63.648-88.932 63.455 98.146-.644 12.29-.115.185.052 1.009-13.051 249.328h17.438l2.093-128.783 63.3-97.906z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 79",
    cx: 265.17,
    cy: 9.47,
    rx: 265.17,
    ry: 9.47,
    transform: "translate(79.178 580.239)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 80",
    cx: 122.254,
    cy: 11.623,
    rx: 122.254,
    ry: 11.623,
    transform: "translate(594.882 643.087)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6274",
    fill: "#2f2e41",
    d: "M328.851 298.711h30.994v290.998h-30.994z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 478",
    d: "M486.404 365.003H296.136v-53.378h190.268l55.1 26.689z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 479",
    d: "M486.404 360.699H296.136v4.3h190.268l55.1-26.689-4.443-2.152z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 480",
    d: "M203.154 435.6h190.268v-53.378H203.154l-55.1 26.689z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 481",
    d: "M152.497 406.759l-4.443 2.152 55.1 26.689h190.268v-4.3H203.154z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6275",
    fill: "#f80",
    d: "M402.892 321.956h32.716v32.716h-32.716z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 81",
    cx: 16.358,
    cy: 16.358,
    r: 16.358,
    transform: "translate(254.81 392.553)",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 82",
    cx: 9.47,
    cy: 9.47,
    r: 9.47,
    transform: "translate(334.878 327.122)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 83",
    cx: 9.47,
    cy: 9.47,
    r: 9.47,
    transform: "translate(334.878 397.719)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 482",
    d: "M280.638 557.283c0 19.344-11.5 26.1-25.685 26.1q-.493 0-.984-.011a41.546 41.546 0 01-1.951-.089c-12.8-.906-22.749-8.008-22.749-26 0-18.618 23.792-42.111 25.579-43.849l.1-.1s25.69 24.605 25.69 43.949z",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 483",
    d: "M254.022 580.422l9.394-13.127-9.422 14.572-.025 1.507a41.546 41.546 0 01-1.951-.089l1.013-19.354-.008-.15.017-.028.1-1.828-9.441-14.6 9.471 13.233.022.388.765-14.623-8.083-15.091 8.181 12.524.8-30.316v-.1.1l-.133 23.906 8.047-9.477-8.08 11.537-.213 13.092 7.513-12.565-7.545 14.491-.119 7.279 10.908-17.488-10.948 20.028z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 484",
    d: "M677.568 633.543s-12.19 10.265-18.606 9.624-18.606-.642-13.473 6.416 26.305 10.907 35.287 11.548 28.871 1.283 27.588-2.566-2.566-21.814-7.7-23.1-23.096-1.922-23.096-1.922z",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 485",
    d: "M747.533 623.464s-8.983 13.164-15.335 14.27-18.094 4.382-11.253 9.8 28.268 3.436 37.093 1.64 28.154-6.523 25.883-9.886-8.335-20.322-13.623-20.178-22.765 4.354-22.765 4.354z",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 486",
    d: "M670.427 435.203s-8.257 56.55-6.333 66.815 3.208 26.3 3.208 26.3-1.283 13.473 0 19.889 8.982 67.366 8.982 68.65-1.283 5.133 0 8.341 3.849.642 0 5.774-1.283 6.416-.642 6.416 25.663 2.566 26.947 0-.642-3.208 0-6.416 1.283-3.849 2.566-4.491 3.849.642 1.925-2.566-6.416-7.057-5.133-8.982-.642-16.04-.642-16.04-1.283-31.438-1.925-50.685 5.774-39.137 5.774-39.137a73.407 73.407 0 0016.681 42.986c16.681 19.889 25.022 57.1 25.022 57.1s3.849 5.774 1.925 10.907-7.7 1.925-1.925 5.133 25.663-1.283 27.588-3.208-2.566-4.491-1.283-9.624 6.416-3.849 1.925-6.416-5.774-1.925-5.774-4.491-11.546-58.378-29.512-74.421l-1.283-58.384s16.04-41.061-.642-44.911-67.449 11.461-67.449 11.461z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 487",
    d: "M682.058 283.237s10.907 26.947 8.341 30.8 31.438-12.832 31.438-12.832-10.907-26.947-10.907-30.154-28.872 12.186-28.872 12.186z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 84",
    cx: 23.739,
    cy: 23.739,
    r: 23.739,
    transform: "translate(666.34 242.497)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 488",
    d: "M721.836 290.295s-16.681-1.925-25.022 8.341-9.624 12.832-9.624 12.832-19.889 32.079-16.04 48.119a46.427 46.427 0 012.566 4.491c1.283 2.566 1.283 38.5 0 44.269s-2.566 7.7-1.283 16.04-10.265 21.814 3.208 24.38 23.739.642 28.23-5.133.642-9.624 14.756-9.624 23.1-9.624 23.1-9.624-7.057-7.7-4.491-8.982 0-4.491-1.283-7.7-1.283-5.774.642-5.774.642-1.283-.642-4.491 22.455-58.384 8.341-74.424-21.174-25.021-21.174-25.021 2.566-9.624-1.284-7.699z",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 489",
    d: "M685.266 351.246v28.23l-20.531 68.008s-13.473 35.287 0 35.287 12.751-33.68 12.751-33.68l28.952-51.009s11.549-40.42 10.265-43.628-31.437-3.208-31.437-3.208z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 490",
    d: "M696.173 309.542s-19.248 7.7-14.115 28.23 0 19.889 0 19.889 26.305-2.566 34.646 3.208l1.925-7.7s7.699-44.269-22.456-43.627z",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 491",
    d: "M681.972 248.414a9.471 9.471 0 01-8.9-1.385 7.167 7.167 0 01-2.022-8.461c1.228-2.411 3.856-3.734 6.376-4.72a59.257 59.257 0 0117.366-3.921c2.838-.2 5.819-.17 8.352 1.127 1.253.642 2.342 1.567 3.583 2.232 2.282 1.222 4.938 1.494 7.4 2.28a18.533 18.533 0 0111.326 10.411 22.331 22.331 0 011.4 5.168 28.786 28.786 0 01-1.5 14.41c-2.735 7.282-8.471 13.648-8.795 21.419-3.511-2.547-4.813-7.145-7.626-10.446a14.209 14.209 0 00-8.109-4.7 4.517 4.517 0 01-2.417-.881 3.892 3.892 0 01-.883-2.059l-2.4-11.342c-.489-2.308-1.107-4.825-3-6.228a9.09 9.09 0 00-3.915-1.379 61.42 61.42 0 00-10.03-.915",
    fill: "#2f2e41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSign);
export default __webpack_public_path__ + "static/media/road-sign.f3238850e86276009626dc674faccd33.svg";
export { ForwardRef as ReactComponent };